// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import { permission } from './directives/permission'
import iView from 'iview'
import 'iview/dist/styles/iview.css'

import 'assets/styles/index.scss'
import 'assets/styles/iview.scss'
window.Promise = Promise;

Vue.use(iView)

Vue.config.productionTip = false

Vue.prototype.checkPermission = (value) => {
  const permissions = store.getters.permission
  return permissions.includes(value)
}

import { getToken,  setToken, setManager, getManager } from '@/utils/Auth'
import { API_URL } from '@/utils/Global'
import CommonManager from 'api/CommonManager'
import AuthManager from 'api/AuthManager'

function hasPermission(permission, to) {
  let allow = false
  permission.forEach(item => {
    if (to.path == item || (to.matched[1] && to.matched[1].path == item)) {
      return allow = true
    }
  })
  return allow
}

function noPermission(permission, to, next) {
    if (to.path == '/approve/index/contract') {
      if (permission.includes('/approve/index/ad')) {
        next({
          path: '/approve/index/ad'
        })
      } else if (permission.includes('/approve/index/invoce')) {
        next({
          path: '/approve/index/invoce'
        })
      } else if (permission.includes('/approve/index/customer')) {
        next({
          path: '/approve/index/customer'
        })
      } else {
        next({
          path: '/page/404'
        })
      }
    } else if (to.path == '/dashboard/index') {
      next({
        path: '/message/index'
      })
    } else {
      next({
        path: '/page/404'
      })
    }
}


router.beforeEach((to, from, next) => {
  let ua = window.navigator.userAgent.toLowerCase()
  iView.LoadingBar.start()
  let title = typeof (to.meta.title) == "undefined" ? '' : to.meta.title
  /* if (process.env.SYSTEM_ENV === 'yun') {
    if (store.getters.siteInfo === null) {
      CommonManager.siteInfo().then(result => {
        if (result) {
          store.commit('SET_SITEINFO', result)
          if (typeof to.meta.title !== undefined){
            window.document.title = title + result.setting_name
          }
        }
      })
    }else{
      if (typeof to.meta.title !== undefined) {
        window.document.title = title + store.getters.siteInfo.setting_name
      }
    }
  }else{
    window.document.title = title + '长江院CRM'
  } */
  window.document.title = title + '长江院CRM'

  if (to.path === '/') {
    next({
      path: '/dashboard/index'
    })
  }

  let token = getToken()
  if (token && token != "undefined") {
    if (to.path === '/login' || to.path === '/bind') {
      next({
        path: '/dashboard'
      })
      iView.LoadingBar.finish()
    } else if(to.path === '/') {
      next({
        path: '/dashboard/index'
      })
    }else{
      if (store.getters.permission.length === 0) {
        CommonManager.permissions().then(result => {
          if(result.data && result.data.length){
            store.commit('SET_PERMISSION', result.data)
            if (hasPermission(store.getters.permission, to) || to.path === '/page/404') {
              next()
            } else {
              noPermission(result.data, to, next)
              iView.LoadingBar.finish()
            }
          }
        })
      } else {
        if (hasPermission(store.getters.permission, to) || to.path === '/page/404') {
          next()
        } else {
          noPermission(store.getters.permission, to, next)
          iView.LoadingBar.finish()
        }
      }
    }
  } else {
    if (ua.match(/DingTalk/i) == 'dingtalk') {
      if (typeof (to.query.token) != "undefined") {
        AuthManager.isLogin(to.query.token).then(result => {
          if(result.data){
            setToken(result.token)
            setManager(result.data.manager)
            //window.location.href = API_URL + '/#/dashboard/index'
            next({
              path: '/dashboard/index'
            })
          }
        })
      }else{
        window.location.href = API_URL + '/wx/authorize'
      }
    }else{
      if (to.path === '/login' || to.path === '/bind') {
        next()
      } else {
        next('/login')
      }
    }
    iView.LoadingBar.finish()
  }
})

router.afterEach((to, from, next) => {
  iView.LoadingBar.finish()
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  directives: {
    permission
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js